"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSuccessNotification = exports.SuccessNotification = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const SuccessNotification_1 = require("@reactionable/core/lib/ui/notification/SuccessNotification");
const Alert_1 = require("../alert/Alert");
const Notification_1 = require("./Notification");
const SuccessNotification = (_a) => {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    const variant = "success";
    return (jsx_runtime_1.jsx(Notification_1.Notification, Object.assign({ variant: variant }, props, { children: jsx_runtime_1.jsx(Alert_1.Alert, Object.assign({ variant: variant, icon: { icon: free_solid_svg_icons_1.faCheckCircle }, className: "mb-0" }, { children: children }), void 0) }), void 0));
};
exports.SuccessNotification = SuccessNotification;
const useSuccessNotification = (props) => {
    return SuccessNotification_1.useSuccessNotification(Object.assign(Object.assign({}, props), { Component: exports.SuccessNotification }));
};
exports.useSuccessNotification = useSuccessNotification;
//# sourceMappingURL=SuccessNotification.js.map